import type { IconData } from '@stacksjs/iconify-core'

export const screenDesktop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M40 392h200v72h-80v32h192v-32h-80v-72h200a24.03 24.03 0 0 0 24-24V72a24.03 24.03 0 0 0-24-24H40a24.03 24.03 0 0 0-24 24v296a24.03 24.03 0 0 0 24 24m8-312h416v280H48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default screenDesktop
